module.exports = __webpack_public_path__ + "media/images/emblems/Gsteig_bei_Gstaad-coat_of_arms-cb5719c1afd53bd78daad197efa1df7e.svg";